import { render, staticRenderFns } from "./credithc.vue?vue&type=template&id=65c0af50&"
import script from "./credithc.vue?vue&type=script&lang=js&"
export * from "./credithc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports